import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import ResponseBlockGenerator from '../components/ResponseBlockGenerator';
import { gAPI_Favourite } from '../../../../../constants/APIs';

export default class FavResponse extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <ResponseBlockGenerator getUrl={gAPI_Favourite} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
